import { useEffect, useMemo, useState } from 'react'
import { usePathname } from 'next/navigation'

import { useTenant } from '@rewardops/auth'
import { useLocale } from '@rewardops/ui'

type UseUICustomizations = {
  defaultRows: number
  defaultItemsAllowed: number
  setItemsAllowedPerPage: (itemsAllowed: number) => void
  isRetailer: boolean
}

const useUICustomizations = ({
  defaultRows,
  defaultItemsAllowed,
  setItemsAllowedPerPage,
  isRetailer,
}: UseUICustomizations) => {
  const pathname = usePathname()
  const { locale } = useLocale()
  const tenant = useTenant()

  const [config, setConfig] = useState({
    rowsAllowed: defaultRows,
    itemsAllowed: defaultItemsAllowed,
  })

  const pageName = useMemo(() => {
    const defaultPage = 'homePage'
    const pageName = pathname?.split(locale)?.[1]?.replace('/', '')

    if (pageName) {
      return `${pageName}Page`
    }

    return defaultPage
  }, [pathname])

  const pageConfig = (tenant?.uiCustomizations?.retailers as any)?.[pageName]

  useEffect(() => {
    if (pageConfig) {
      setConfig((prev) => ({
        ...prev,
        itemsAllowed:
          pageConfig?.featuredCarousel?.itemsAllowedPerPage ??
          defaultItemsAllowed,
        rowsAllowed: pageConfig?.featuredCarousel?.rows ?? defaultRows,
      }))
    }
  }, [pageConfig])

  useEffect(() => {
    if (isRetailer) {
      setItemsAllowedPerPage(config?.itemsAllowed * config?.rowsAllowed)
    }
  }, [config])

  return {
    ...config,
    pageConfig,
  }
}

export { useUICustomizations }
